import scheduledTasksController from './scheduledTasksController'

export default scheduledTasksController



// WEBPACK FOOTER //
// ../src/controllers/scheduledTasksController/index.js